import { LoadState } from "../../../constants/enum";
import { IPaymentGateway, IPaymentGatewayState } from "./payment-gateway.types";


export const defaultPaymentGateway: IPaymentGateway = {
    payment_gateway_uuid: null,
    payment_gateway: "STRIPE",
    outlet_uuid: "",
    outlet_name: "",
    gateway_secret_key: "",
    webhook_secret_key: "",
    website_base_url: "",
    payment_success_url: "",
    payment_failed_url: "",
    comment: "",
    status: "ACTIVE",
}


export const defaultPaymentGatewayState: IPaymentGatewayState = {
    payment_gateway_list: {
        loading: LoadState.idle,
        data: [],
        count: 0,
        error: null,
    },
    single_payment_gateway: {
        loading: LoadState.idle,
        data: defaultPaymentGateway,
        error: null,
    },
}